module.exports = __webpack_public_path__ + "img/lytewm.b30e0444.png";